import { ELandingType } from '../../node/types/recommendations';
import { TSectionType } from './sectionType';

export const mapSectionToLandingType = (section: TSectionType) => {
  switch (section) {
    case 'daily-rent':
      return ELandingType.FlatRentForDay;
    case 'sale':
      return ELandingType.SecondaryFlatSale;
    case 'rent':
      return ELandingType.FlatRent;
    case 'countryside':
      return ELandingType.SuburbanSale;
    case 'index':
    default:
      return ELandingType.MainPage;
  }
};
